import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

type StepTypes =
    | "cartStep"
    | "loginStep"
    | "userInfoStep"
    | "paymentStep"
    | "confirmationStep";

const TOOL_CHECKOUT_STEPS: Record<StepTypes, StepVariables> = {
    cartStep: {
        stepName: "cart",
        stepNumber: 1,
        placement: "bestellen:winkelmandje",
        result: {},
        option: "",
    },
    loginStep: {
        stepName: "login/register",
        stepNumber: 2,
        placement: "bestellen:login",
        result: {},
        option: "",
    },
    userInfoStep: {
        stepName: "personal info",
        stepNumber: 3,
        placement: "bestellen:persoonlijke-info",
        result: {}, // customerid
        option: "",
    },
    paymentStep: {
        stepName: "payment method",
        stepNumber: 4,
        placement: "bestellen:betalen",
        result: {}, // customerid
        option: "",
    },
    confirmationStep: {
        stepName: "order confirmation",
        stepNumber: 5,
        placement: "bestellen:bevestiging",
        result: {}, // customerid + deliverymethod
        option: "", // paymentmethod
    },
};

const TOOL_CHECKOUT_CONTEXT: Readonly<ToolContext> = {
    name: "checkout", // specific name
    type: "checkout",
};

export { TOOL_CHECKOUT_STEPS, TOOL_CHECKOUT_CONTEXT };
